import { useQuery } from '@tanstack/react-query';
import { BaseHTTPError } from '@fe-core/errors';
import { useConfigContext } from '@fe-core';
import { getSessionChildren } from '@api/queries/session';
import { TSessionChildren } from '@api/io/session.children.io';

export const SESSION_CHILDREN_QUERY_KEY = 'session-children';

export const useSessionChildren = ({
  sessionId,
  enabled = true,
}: {
  sessionId: string;
  enabled?: boolean;
}) => {
  const { config } = useConfigContext();
  const baseUrl = config.apiUrls.ccapi;

  return useQuery<TSessionChildren, BaseHTTPError>({
    queryKey: [SESSION_CHILDREN_QUERY_KEY, sessionId],
    queryFn: () =>
      getSessionChildren({ baseUrl: baseUrl as string, sessionId }),
    retry: false,
    enabled: enabled && !!baseUrl,
  });
};
